import * as React from 'react';
import { useState, useEffect } from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import { FxIconValuePanelNoChart } from "./components/FxIconValuePanelNoChart";
import { AttrList } from "../fxms/datas/OpClass";
import { FxmsData } from "../fxms/datas/FxData";
import { FxDataSearch } from "../fxms/inputs/FxDataSearch";
import { FxPopupOpener,FxWindow  } from "../fxms/windows/FxWindows";

import { Button } from '@mui/material';
import { UI_0_2 } from "./ui/UI_0_2";
import { VupPlantDash } from './VupPlantDash';
import { FxOpenContent } from '../fxms/windows/FxWindows';
import { toKSTISOString } from "./common/commonMethod";

export const VupComplexDash = (props) => {
    const plantOpenRef = React.useRef(null);
    const popupOpenRef = React.useRef(null);
    const [filter, setFilter] = useState([]);
    const [inloList, setInloList] = useState([]);
    const [values, setValues] = useState({});
    const [complexInloName, setComplexInloName] = useState();
    const [addr, setAddr] = useState();
    const [inputData, setInputData] = useState(0);
    const inloClCd = 'PLANT';

    let engList = FxmsData.getDatas("energy");
    let complexInlo = null;


    /**
     * 생산량 데이터 가져오기
     * @param {*} inputData
     */
    async function showDatas(inputData) {
        console.log("what's inputData ? : ", inputData);

        const tmpValue = {};
        engList = FxmsData.getDatas("energy");
        if (engList === undefined || engList === null) {
            return;
        }
        if (complexInlo === null) {
            return;
        }

        for (let e of engList) {
            tmpValue[e.engId] = {};
        }

        if (inputData === 0) {
            let today = new Date();
            const todayStr = toKSTISOString(today);
            let date = todayStr.replaceAll("-", ".");
            console.log("check date : ", date);
            inputData = { prodDateStart: date, prodDateEnd: date };
        }

        const para = inputData ? { ...inputData } : {};
        para.inloClCd = inloClCd;
        para.complexInloNo = complexInlo.inloNo;

        const list = await FxmsData.GET("vup/dash/toc", para);

        for (const data of list.data) {
            if (tmpValue[data.engId] && data.inloNo) {
                if (tmpValue[data.engId][data.inloNo]) {
                    tmpValue[data.engId][data.inloNo].now = data.prodAmt;
                    tmpValue[data.engId][data.inloNo].sum += data.prodAmt;
                    tmpValue[data.engId][data.inloNo].list.push(data);
                } else {
                    tmpValue[data.engId][data.inloNo] = {};
                    tmpValue[data.engId][data.inloNo].list = [];
                    tmpValue[data.engId][data.inloNo].now = data.prodAmt;
                    tmpValue[data.engId][data.inloNo].sum = data.prodAmt;
                    tmpValue[data.engId][data.inloNo].list.push(data);
                }
            }
        }

        console.log('*** VupComplexDash *** energy', engList);
        console.log('*** VupComplexDash *** select-datas', list);
        console.log('*** VupComplexDash *** show-datas', tmpValue);

        setValues(tmpValue);
    }

    function getValue(inloNo, engId) {
        if (values && values[engId] && values[engId][inloNo]) {
            return values[engId][inloNo];
        } else {
            return { now: "-", sum: "-" };
        }
    }

    function clickButton(inputData) {
        setInputData(inputData);
        showDatas(inputData);
    }

    function onChangeDatas(datas) {
        console.log("*** FxCrud ***  onChangeDatas", datas);
        setInputData(datas);
    }


    useEffect(() => {

        let attr;
        const attrListClass = new AttrList("filter");
        // filterList.addTitle("산단 : " + complexInlo.inloName);
        attr = attrListClass.addSelect("complexInloNo", "산단명", '{"type":"inlo"}', function (datas) {
            if (datas && datas.complexInloNo >= 0) {

                complexInlo = FxmsData.getInlo(datas.complexInloNo);
                if (FxmsData.isDebug) console.log("----------------------------------------------------------------", datas);
                const tmpInloList = FxmsData.getDatas("inlo", { inloClCd: inloClCd, complexInloNo: datas.complexInloNo });
                if (tmpInloList) {
                    setInloList(tmpInloList);
                    setValues(null);
                    showDatas(datas);
                }
            }
        }, "right");
        attr.attrValType = "inlo";
        attr.attrValObj = { inloClCd: "COMPLEX" };
        attr.uiWidth = 200;
        attrListClass.addDate("prodDateStart", "조회기간", "right").attrDftVal = "day,-7";
        attrListClass.addDate("prodDateEnd", "~", "right");
        attrListClass.addButton("검색", clickButton, "right");

        // return에 넣으면 계속 렌더링하여 입력된 값이 없어짐.
        setFilter(
            <FxDataSearch
                attrList={attrListClass.getList()}
                // onShowData={onShowData}
                onChangeDatas={onChangeDatas}
                inputType="Search"
            />
        );

        FxWindow.showNavigator("산단 대시보드");

    }, []);


    useEffect(() => {
        showDatas();

    }, [inloList]);

    return (
        <StyledEngineProvider injectFirst>
            <div className="FxCrudFilter">{filter}</div>
            <div className={"VupComplexDash"}>
                <div className={"line1Area"}>
                    {
                        engList ? engList.map((energy, index) => {
                            return (
                                <FxIconValuePanelNoChart key={energy.engId} energy={energy} inloList={inloList} allValues={values} />
                            )
                        }) : ""}
                </div>

                <div className="line2Area collectFactory">
                    {inloList.map((inlo, index) => {
                        return (
                            <a key={index} href={"#section" + index}>
                                <div className="factoryList" >
                                    <img style={{ verticalAlign: 'text-top' }} src="icon_factory.png" />{inlo.inloName}</div></a>)
                    })}
                </div>
                <div className="line3Area">
                    <div className="factoryListBox">
                        <div className="facList">
                            {inloList.map((inlo, index) => {
                                return (
                                    <div key={index} className="factoryBox" id={"section" + index}>
                                        <div className="titleArea">
                                            <img src="iconFac.png" onClick={function() {
                                                localStorage.setItem("plantInfoJson", JSON.stringify(inlo));
                                                plantOpenRef.current();
                                            }}/><span className="facName" onClick={function() {
                                                localStorage.setItem("plantInfoJson", JSON.stringify(inlo));
                                                plantOpenRef.current();
                                            }}>{inlo.inloName}</span>
                                                <span style={{float: "right"}}>
                                                    <Button className='factoryBoxBtn' onClick={function () {
                                                        localStorage.setItem("plantInfoJson", JSON.stringify(inlo));
                                                        setComplexInloName(JSON.parse(localStorage.getItem("plantInfoJson")).complexInloName);
                                                        setAddr(JSON.parse(localStorage.getItem("plantInfoJson")).addr);
                                                        localStorage.setItem('filterDate', JSON.stringify({ prodDateStart: inputData.prodDateStart, prodDateEnd: inputData.prodDateEnd, inloNo: JSON.parse(localStorage.getItem("plantInfoJson")).inloNo }));
                                                        popupOpenRef.current();
                                                        }}>차트보기
                                                    </Button></span></div>
                                        <div className="factoryData">
                                            <ul>
                                                {engList.map((eng, index) => {
                                                    return <li key={inlo.inloNo + "_" + eng.engId}>{eng.engName} <p className="blue">{getValue(inlo.inloNo, eng.engId).now}<span>ton/h</span></p></li>;
                                                })}
                                            </ul>
                                        </div>
                                    </div>
                                )
                            })}


                        </div>
                    </div>
                </div>


            </div>

            <FxOpenContent openRef={plantOpenRef}>
                <VupPlantDash />
            </FxOpenContent>

            <FxPopupOpener openRef={popupOpenRef} title={complexInloName} addr={addr}>
                <UI_0_2 />
            </FxPopupOpener>


        </StyledEngineProvider>
    );
}